module.exports = __webpack_public_path__ + "img/person.2e7441a8.svg";